import { ActionBase } from '../../../core/store/action/ActionBase';
import { ExtractModel } from "../../models/ExtractModel";

export const GENERATE_CHILD_EXTRACTS = '[Extract] Generate Child Extracts';

export class GenerateChildExtractsAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GENERATE_CHILD_EXTRACTS;

  constructor(public payload: { extractKey: string, model: ExtractModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GenerateChildExtractsAction.ts